import { render, staticRenderFns } from "./EModalTransferirMatricula.vue?vue&type=template&id=753fb731&scoped=true"
import script from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"
export * from "./EModalTransferirMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753fb731",
  null
  
)

export default component.exports